import React from 'react';
import { Outlet } from 'react-router';
import { Stack } from '../../design-system/stack/stack';

const AccountsPage: React.FC = () => {
  return (
    <Stack align="stretch" className="min-h-screen py-2 pr-2">
      <Stack align="stretch" className="flex-1 overflow-clip rounded-md border border-border bg-background shadow-xs">
        <Outlet />
      </Stack>
    </Stack>
  );
};

export default AccountsPage;
